
export default {
  data() {
    return { open: false }
  },
};
